import { setupFormState } from '@/components/form/tidal-form'

import { TestPhoneNotificationFormValues } from './types'

export const form = setupFormState<TestPhoneNotificationFormValues>({
  id: 'TestPhoneNotificationForm',
  initialValues: {
    id: '',
    phoneNumber: '',
  },
})
